// The menu: who sees what, which module each entry belongs to, and the phone's bottom tabs.
import type { Role } from "../../lib/types";

export type CountKey = "calls" | "approvals" | "queue" | "matches" | "inbox" | "dial";
export interface NavItem { h: string; l: string; ic: string; roles: Role[]; mod?: string; count?: CountKey; tab?: string }
export type NavEntry = NavItem | { sec: string; roles: Role[] };

const ALL: Role[] = ["rep", "caller", "manager", "admin"];
export const NAV: NavEntry[] = [
  { h: "/today", mod: "today", l: "Today", ic: "today", roles: ALL, tab: "Today" },
  { h: "/dial", mod: "leads", l: "Dial list", ic: "dial", roles: ["caller", "rep"], count: "dial", tab: "Dial" },
  { h: "/accounts", l: "Accounts", ic: "building", roles: ["rep", "manager", "admin"], tab: "Accounts" },
  { h: "/leads", mod: "leads", l: "Leads", ic: "sprout", roles: ALL, tab: "Leads" },
  { h: "/pipeline", mod: "leads", l: "Opportunities", ic: "target", roles: ["rep", "manager", "admin"] },
  { h: "/calls", l: "Calls", ic: "phone", roles: ALL, count: "calls", tab: "Calls" },
  { h: "/quotes", mod: "quotes", l: "Quotes", ic: "receipt", roles: ["rep", "manager", "admin"], tab: "Quotes" },
  { h: "/tasks", mod: "today", l: "Tasks", ic: "check", roles: ALL },
  { h: "/visits", mod: "coaching", l: "Field visits", ic: "pin", roles: ["rep", "manager"] },
  { h: "/qa", mod: "coaching", l: "Call coaching", ic: "headphones", roles: ALL },
  { h: "/me", l: "My numbers", ic: "chart", roles: ["rep", "manager"], tab: "Numbers" },
  { h: "/inbox", l: "Notifications", ic: "bell", roles: ALL, count: "inbox", tab: "Inbox" },
  { sec: "Manage", roles: ["manager", "admin"] },
  { h: "/approvals", mod: "quotes", l: "Approvals", ic: "pen", roles: ["manager", "admin"], count: "approvals", tab: "Approvals" },
  { h: "/floor", mod: "coaching", l: "Live floor", ic: "pulse", roles: ["manager", "admin"], tab: "Floor" },
  { h: "/team", l: "Team", ic: "users", roles: ["manager", "admin"], tab: "Team" },
  { h: "/campaigns", mod: "leads", l: "Campaigns", ic: "list", roles: ["manager", "admin"] },
  { h: "/reports", mod: "coaching", l: "Reports", ic: "bars", roles: ["manager", "admin"] },
  { h: "/money", mod: "quotes", l: "Money integrity", ic: "shield", roles: ["manager", "admin"], tab: "Money" },
  { h: "/automations", mod: "coaching", l: "Automations", ic: "bolt", roles: ["admin"] },
  { sec: "Operate", roles: ["ops", "admin"] },
  { h: "/ops", mod: "quotes", l: "Execute queue", ic: "gear", roles: ["ops", "admin"], count: "queue", tab: "Queue" },
  { h: "/matches", mod: "quotes", l: "Confirm matches", ic: "link", roles: ["rep", "manager", "admin", "ops"], count: "matches", tab: "Matches" },
  { h: "/admin", l: "Admin", ic: "wrench", roles: ["admin"], tab: "Admin" },
];
export const isItem = (x: NavEntry): x is NavItem => "h" in x;

/** Bottom tabs on phones, per role; topped up to five from FILL. */
export const BOTTOM: Record<Role, string[]> = {
  rep: ["/today", "/accounts", "/calls", "/quotes", "/me"],
  caller: ["/dial", "/today", "/leads", "/calls", "/inbox"],
  manager: ["/approvals", "/floor", "/today", "/team", "/calls"],
  admin: ["/team", "/approvals", "/money", "/ops", "/admin"],
  ops: ["/ops", "/matches"],
};
export const FILL = ["/calls", "/accounts", "/me", "/team", "/inbox"];

/** Which module a route belongs to (first path segment). A route in a module that's off sends you home. */
export const ROUTE_MOD: Record<string, string> = {
  today: "today", tasks: "today", dial: "leads", leads: "leads", lead: "leads", pipeline: "leads", campaigns: "leads", campaign: "leads",
  quotes: "quotes", quote: "quotes", approvals: "quotes", money: "quotes", ops: "quotes", matches: "quotes",
  visits: "coaching", qa: "coaching", floor: "coaching", reports: "coaching", automations: "coaching",
};

/** Is `path` inside this menu entry (its detail pages too)? */
export function navOn(h: string, path: string) {
  return path === h || path.startsWith(h + "/") || (h === "/accounts" && path.startsWith("/account/"))
    || (h === "/quotes" && path.startsWith("/quote")) || (h === "/leads" && path.startsWith("/lead/"));
}
